import {
  AutoBidNotOrderedMarket,
  type AutoBidNotOrderedNotice,
} from '@ebalance/proto/bffuser/v1/auto_bid_notice_model_pb'

import type { SideMenuDot } from '~/models/sideMenuDot'
import { routePaths } from '~/routes/routePaths'

const MARKET_MENU_PATH: Partial<Record<AutoBidNotOrderedMarket, string>> = {
  [AutoBidNotOrderedMarket.SPOT]: routePaths.biddingSpot.path,
  [AutoBidNotOrderedMarket.INTRADAY]: routePaths.biddingIntraday.path,
}

/**
 * AC-SC-041: 自動入札が発注しなかったコマの記録がある市場の項目 (スポット市場 /
 * 時間前市場) に黄のドットを作る。応答は表示期間内で未解消の記録だけなので、
 * 市場ごとに 1 件以上あるかだけを見る。親グループのドットは子の項目からまとめる。
 *
 * @param reason 表示文言 (i18n 解決済み)
 */
export const autoBidNotOrderedDots = (
  notices: readonly AutoBidNotOrderedNotice[],
  reason: string,
): Array<readonly [string, SideMenuDot]> => {
  const paths = new Set<string>()
  for (const notice of notices) {
    const path = MARKET_MENU_PATH[notice.market]
    if (path !== undefined) paths.add(path)
  }
  return [...paths].map(
    (path) => [path, { severity: 'warning', reasons: [reason] }] as const,
  )
}
